import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const maintenanceContract = c.router({
  fixReleasedDeclarations: {
    method: 'POST',
    path: '/maintenance/fix-released-declarations',
    body: c.noBody(),
    responses: {
      200: z.object({
        fixedDeclarations: z.number(),
        duration: z.string(),
      }),
    },
  },
  setLowValueTemplateType: {
    method: 'POST',
    path: '/maintenance/set-low-value-template-type',
    body: c.noBody(),
    responses: {
      200: z.object({ status: z.string() }),
    },
  },
  setBatchesTemplateType: {
    method: 'POST',
    path: '/maintenance/set-batches-template-type',
    body: c.noBody(),
    responses: {
      200: z.object({ status: z.string(), data: z.object({ updated: z.number(), lowValue: z.number(), highValue: z.number() }) }),
    },
  },
  setDeclarationsComplianceCheck: {
    method: 'POST',
    path: '/maintenance/set-declarations-compliance-check',
    body: c.noBody(),
    responses: {
      200: z.object({ status: z.string(), data: z.object({ updated: z.number() }) }),
    },
  },
  addAnalysisStatusToExistingHighValues: {
    method: 'POST',
    path: '/maintenance/add-analysis-status-to-existing-high-values',
    body: c.noBody(),
    responses: {
      200: z.object({ status: z.string(), data: z.object({ updatedBatches: z.number(), updatedDeclarations: z.number() }) }),
    },
  },
  updateDutiesAndTaxesStructure: {
    method: 'POST',
    path: '/maintenance/update-duties-taxes-structure',
    body: c.noBody(),
    responses: {
      200: z.object({ status: z.string(), data: z.object({ updatedDeclarations: z.number() }) }),
    },
  },
});
